'use client'
import { useState } from 'react'

import EmailIcon from '../../../../public/svg/email.svg'
import FacebookIcon from '../../../../public/svg/facebook.svg'
import LinkedInIcon from '../../../../public/svg/linkedin.svg'
import ShareIcon from '../../../../public/svg/share.svg'
import styles from './Share.module.css'

export type ShareProps = {
  title: string
  facebook?: boolean
  linkedin?: boolean
  email?: boolean
  className?: string
}

export const PhnxShare: React.FC<ShareProps> = ({
  title,
  facebook,
  linkedin,
  email,
  className,
}) => {
  const [showSShare, setShowShare] = useState(false)
  const handleShare = () => {
    setShowShare(!showSShare)
  }
  let url = ''
  if (typeof window !== 'undefined') {
    url = window.location.href
  }
  //encode url
  const encodedUrl = encodeURIComponent(url)

  const fb = `https://www.facebook.com/sharer/sharer.php?${encodedUrl}`

  const li = `https://www.linkedin.com/feed/?linkOrigin=LI_BADGE&shareActive=true&shareUrl=${encodedUrl}`

  const em = `https://outlook.office.com/mail/deeplink/compose?mailtouri=mailto%3A%3Fsubject%3D${title}%26body%3D${encodedUrl}`

  return (
    <div className={`${styles.share} ${styles['details-container']} ${className}`}>
      <button className="inner" onClick={handleShare} aria-label="Share this page">
        <ShareIcon />
      </button>
      <button className="text" aria-label="Share this page" onClick={handleShare}>
        Share
      </button>
      {showSShare && (
        <div className={styles.shareOpen}>
          <ul>
            {facebook && (
              <li>
                <a href={fb} className={`${styles.facebook} ${styles.socialLink}`}>
                  <FacebookIcon />
                </a>
              </li>
            )}
            {linkedin && (
              <li>
                <a href={li} className={`${styles.linkedin} ${styles.socialLink}`}>
                  <LinkedInIcon />
                </a>
              </li>
            )}
            {email && (
              <li>
                <a href={em} className={`${styles.emails} ${styles.socialLink}`}>
                  <EmailIcon />
                </a>
              </li>
            )}
          </ul>
        </div>
      )}
    </div>
  )
}
